import { useMemo } from 'react'
import { ParagraphSM } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { CheckInputButton } from '../../components/CheckInputButton'
import { Page } from '../../components/Page'
import { PageHeading } from '../../components/PageHeading'
import {
  TorchApplicationStatus,
  TorchApplicationTypes,
  useTorchApplication,
} from '../../components/TorchApplicationContext'
import { useDelayedSelection } from '../../components/useDelayedSelection'
import { TORCH_APPLICATION_FEE } from '../../utils/payment'
import { useUpdateTorchApplicationProject } from '../AssociatedProject/hooks/useUpdateTorchApplicationProject'
import { TorchApplicationTypeIcon } from './TorchApplicationTypeIcon'

export const TorchTypeSelection = () => {
  const { t } = useTranslate('guild-create')
  const {
    setPage,
    pageStepIndex,
    setPageStep,
    type,
    updateType,
    id,
    isDraft,
    applicationProjectId,
    status,
    setApplicationProjectId,
  } = useTorchApplication()
  const [updateTorchApplicatioProject] = useUpdateTorchApplicationProject()
  const [selection, onClick] = useDelayedSelection(async (name) => {
    if (
      status === TorchApplicationStatus.Draft &&
      type === TorchApplicationTypes.CompletedEpisode &&
      name !== TorchApplicationTypes.CompletedEpisode &&
      id &&
      applicationProjectId
    ) {
      // If a draft applciation was an episode application and now is not, clear the project id.
      await updateTorchApplicatioProject({
        variables: {
          input: {
            id,
            projectId: null,
          },
        },
      })

      setApplicationProjectId(null)
    }
    updateType(name as TorchApplicationTypes)
    id && setPage(2)
  }, type)

  const types = useMemo(
    () => [
      {
        value: TorchApplicationTypes.Concept,
        label: t('conceptVideo', 'Concept Video'),
      },
      {
        value: TorchApplicationTypes.CompletedEpisode,
        label: t('completedEpisode', 'Completed Episode'),
      },
      {
        value: TorchApplicationTypes.CompletedMovie,
        label: t('completedMovieOrDocumentary', 'Completed Movie or Documentary'),
      },
    ],
    [t],
  )

  const disabled = !selection

  return (
    <Page onBack={pageStepIndex > 0 ? () => setPageStep(0) : undefined} disabled={disabled} onNext={() => setPage(2)}>
      <div className="flex flex-col items-center gap-2">
        <PageHeading>{t('whatWouldYouLikeToSubmit', 'What would you like to submit?')}</PageHeading>

        <ParagraphSM weight="normal">
          {t('aSubmissionFeeWillApply', 'A {{ fee }} submission fee will apply.', { fee: TORCH_APPLICATION_FEE })}
        </ParagraphSM>
      </div>

      <div className="flex flex-col items-stretch gap-4 md:flex-row">
        {types.map(({ value, label }) => (
          <CheckInputButton
            key={value}
            name={value}
            onClick={onClick}
            selected={selection === value}
            className="px-0 py-4"
            disabled={!isDraft}
          >
            <div className="flex flex-col items-center gap-1">
              <TorchApplicationTypeIcon type={value} size={48} color="core-gray-950" />
              <div className="px-3">{label}</div>
            </div>
          </CheckInputButton>
        ))}
      </div>
    </Page>
  )
}
